import { render, staticRenderFns } from "./SwitchConexion.vue?vue&type=template&id=3d8484ff&scoped=true"
import script from "./SwitchConexion.vue?vue&type=script&lang=js"
export * from "./SwitchConexion.vue?vue&type=script&lang=js"
import style0 from "./SwitchConexion.vue?vue&type=style&index=0&id=3d8484ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8484ff",
  null
  
)

export default component.exports